import { IApiError } from '@/models/apiError.model';
import { IGoogleMerchantSettings } from '@/models/googleMerchantSettings.model';

export const SLICE_NAME = 'googleMerchantSettings';

export interface IGoogleMerchantSettingsState {
  data: IGoogleMerchantSettings | null;
  isLoading: boolean;
  error: IApiError | null;
}

export const initialState: IGoogleMerchantSettingsState = {
  isLoading: false,
  error: null,
  data: null,
};
